import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/pages/AboutVision.scss';

function AboutVision() {
  const navigate = useNavigate();

  const values = [
    {
      icon: '🛡️',
      title: 'Integrity',
      description: 'We operate with absolute honesty, transparency, and accountability in every interaction. We believe that trust is the foundation of every successful, long-term relationship.'
    },
    {
      icon: '🏆',
      title: 'Excellence',
      description: 'We strive for the highest quality in every single solution we deliver. From initial architecture and design to final testing and deployment, we reject compromise.'
    },
    {
      icon: '💡',
      title: 'Innovation',
      description: 'We embrace emerging trends, fresh ideas, and modern tools to stay ahead of the curve. Our team is constantly learning to solve new challenges creatively.'
    },
    {
      icon: '🤝',
      title: 'Partnership',
      description: 'We build long-term collaborations built on respect, clear communication, and shared goals. When our clients grow, we grow with them.'
    }
  ];

  return (
    <div className="about-vision-page">
      {/* Hero Section */}
      <section className="vision-hero" style={{ backgroundImage: "linear-gradient(135deg, rgba(10, 37, 64, 0.85), rgba(0, 82, 106, 0.85)), url('/images/about-bg.jpg')" }}>
        <h1>Vision & Mission</h1>
        <p>The core values and purpose that drive our organization forward</p>
      </section>

      {/* Main Content */}
      <div className="vision-page-container">
        {/* Back Button */}
        <div className="back-btn-wrapper">
          <button className="btn-back" onClick={() => navigate('/about')}>
            <span>&larr;</span> Back to About
          </button>
        </div>

        {/* Vision & Mission Cards */}
        <section className="vision-mission-details">
          <div className="vm-detail-card vision-card-detailed">
            <div className="vm-card-badge">01</div>
            <h2>Our Vision</h2>
            <p className="subtitle">WHERE WE ARE HEADED</p>
            <p className="desc">
              To be recognized globally as the most trusted, innovative, and customer-centric technology partner. 
              We envision a future where organizations of all sizes can easily harness the power of software engineering, 
              cloud solutions, and smart automation to make their operations more productive, sustainable, and impactful.
            </p>
            <div className="accent-line"></div>
          </div>

          <div className="vm-detail-card mission-card-detailed">
            <div className="vm-card-badge">02</div>
            <h2>Our Mission</h2>
            <p className="subtitle">WHAT WE DO EVERY DAY</p>
            <p className="desc">
              To empower businesses by developing top-tier software and digital solutions that streamline operations, 
              foster growth, and deliver tangible results. We achieve this through close partnership, active problem-solving, 
              and the implementation of robust development practices.
            </p>
            <div className="accent-line"></div>
          </div>
        </section>

        {/* Core Values Section */}
        <section className="vision-values-section">
          <h2>Our Core Values</h2>
          <p className="section-desc">The foundational principles that guide our choices, engineering, and culture</p>

          <div className="values-grid-detailed">
            {values.map((item, index) => (
              <div key={index} className="value-card-detailed">
                <div className="value-icon-wrapper">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default AboutVision;
